import api from "./axios";

/** FormData can include large cover images and multi-minute videos; default axios timeout is 15s. */
const RECIPE_FORM_TIMEOUT_MS = 20 * 60 * 1000;

export const createRecipe = async (formData) => {
  try {
    const res = await api.post("/admin/recipes", formData, {
      timeout: RECIPE_FORM_TIMEOUT_MS
    });
    return res.response;
  } catch (err) {
    throw err?.response?.data || err;
  }
};

export const updateRecipe = async (id, formData) => {
  try {
    const res = await api.put(`/admin/recipes/${id}`, formData, {
      timeout: RECIPE_FORM_TIMEOUT_MS
    });
    return res.response;
  } catch (err) {
    throw err?.response?.data || err;
  }
};

export const getAdminRecipes = async (params) => {
  try {
    const res = await api.get("/admin/recipes", { params });
    return res.response;
  } catch (err) {
    throw err?.response?.data || err;
  }
};

export const getRecipeById = async (id) => {
  try {
    const res = await api.get(`/admin/recipes/${id}`);
    return res.response.data;
  } catch (err) {
    throw err?.response?.data || err;
  }
};

export const deleteRecipe = async (id) => {
  try {
    const res = await api.delete(`/admin/recipes/${id}`);
    return res.response;
  } catch (err) {
    throw err?.response?.data || err;
  }
};
